import createInstance from '../http';
import config from '@/const/config';
const { request } = createInstance(config.marketBaseUrl);

export default {
  // 首页资源投放 http://mock.qa.91jkys.com/project/180?moduleId=956&interfaseId=7347
  // getResourceList: params => request.get(`/api/resource_publish_b2b/1.0/get_pc_front`, { params }),
  getResourceList: params => request.get(`/api/home/1.0.0/getPcHomeResources`, { ...params, handleError: true }),
  // PC获取首页弹窗 http://mock.qa.91jkys.com/project/180?moduleId=956&interfaseId=7380
  getPopupResource: params => request.get(`/api/resource_front_pop_b2b_2b/1.0/get_pc`, { params }),

  getRecommendWord: () => request.get(`/api/resource_recommend_word_b2b_2b/1.0/get_pc_list`)
};
